import { useEffect, useState } from "react";
import { API_URLS } from "../../apiUrl";
import axiosInstance from "../../components/axiosInstance";

function PropertyTypeDropdown() {
  const [propertyTypes, setPropertyTypes] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const fetchPropertyTypes = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(`${API_URLS.PropertyTypeList}`,
        {
          page: 1,
          limit: 10000
        }
      );

      if (response.data.data.data) {
        const filteredData = response.data.data.data.filter((item: any) => item.status !== 2);
        setPropertyTypes(filteredData);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPropertyTypes();
  }, []);

  const handleDropdownToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsDropdownOpen((prev) => !prev);
  };

  return [handleDropdownToggle, isDropdownOpen, propertyTypes, loading, setIsDropdownOpen]
}

export default PropertyTypeDropdown;